export default __webpack_public_path__ + "static/media/18t.75648508.jpg";